import MenuSecondaryItem from "./MenuSecondaryItem";
import "./css/menu-column.css";

export default function menuColumn(props) {
  return (
    <ul className="menu-column">
      {props?.menuItems?.map((item, index) => {
        return <MenuSecondaryItem key={index} {...item} />;
      })}
    </ul>
  );
}
